module.exports = __webpack_public_path__ + "static/media/04_Update DeliverySlot.9b122512.jpg";